var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1498 6.35C16.6998 4.9 14.7098 4 12.4998 4C8.07977 4 4.50977 7.58 4.50977 12C4.50977 16.42 8.07977 20 12.4998 20C16.2298 20 19.3398 17.45 20.2298 14H18.1498C17.3298 16.33 15.1098 18 12.4998 18C9.18977 18 6.49977 15.31 6.49977 12C6.49977 8.69 9.18977 6 12.4998 6C14.1598 6 15.6398 6.69 16.7198 7.78L13.4998 11H20.4998V4L18.1498 6.35Z",
    fill: "currentColor"
  })));
};

export default SvgRefresh;